module.exports = __webpack_public_path__ + "img/7.2da9a3fd.png";